import { useContext } from "react";
import context from "./context";

const useUrlContext = () => useContext(context);

export default useUrlContext;
